module.exports = __webpack_public_path__ + "img/changsha02.410de7c0.png";